import { UpcomingAppointmentsModel } from "one-card-upcoming-appointments";

/**
 * 
 * @param count contains the total number of colors needed
 */
export const getColorCode = (count: number) => {
    let hexcodes: string[] = ['#fcfbd4','#c6f2aa','#f8a768','#f0c2b9','#a7b8d1'];
    return hexcodes.slice(0, count);
}

/**
 * This Function transforms the backend response
 * in the Data Model that supports the 
 * upcoming Appointments Component
 * @param response has the backend upcoming 
 * appointment response
 * @param context has settings etc..
 */

interface ProviderID {
    ID: string;
    Type:string;
    // ... other properties
  }
  interface DeptID {
    ID: string;
    Type:string;
    // ... other properties
  }
  interface VisitID {
    ID: string;
    Type:string;
    // ... other properties
  }
interface Provider{
    ProviderName: string,
    DepartmentName: string,
    Time: string,
    Duration: string,
    ProviderIDs: ProviderID[],
    DepartmentIDs: DeptID[],
    VisitTypeID:VisitID[]
}
const formatdatestring=(dt:any)=>{
    const dateTime = new Date(dt);

    const year = dateTime.getUTCFullYear();
    const month = dateTime.getUTCMonth() + 1; // Month is zero-indexed, so add 1
    const day = dateTime.getUTCDate();
    let hours = dateTime.getUTCHours();
    let minutes: any = dateTime.getUTCMinutes();
    let seconds = dateTime.getUTCSeconds();

// Format the date and time as needed
const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
return [formattedDate,formattedTime]
}
export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    const { settings:{appointment_config:{filterAppointments}}} = context;

    let result: UpcomingAppointmentsModel = {};
        let totalupcomingappointments: number = 0;
        let noShowCount: number = 0;
        let pastCount: number = 0;
        let completecount: number = 0;
        let upcomingCount: number = 0;
        let cancelledCount: number = 0;
        let data = {};
        let note:string = "";
        let upappointment: any = [];
        if (response && response.length > 0) {
            let resourse=response[0]?.entry
            resourse?.map((ele: any) => {

                let presentdate: number = new Date().getTime();
                let ddate: string = ele?.resource?.start ? formatdatestring(ele?.resource?.start)[0]  : "";
                let dtime: string = ele?.resource?.start ? formatdatestring(ele?.resource?.start)[1]  : "";
                let apptdate: number = new Date(ddate.concat(" ").concat(dtime)).getTime();
                // if (presentdate <= apptdate) {
                //     let ehrProvider = sessionStorage.getItem('ehr');
                //     let preconfigproviderid=Object.keys(filterAppointments[ehrProvider][0]);
                //     let preconfigprovidervalue=filterAppointments[ehrProvider][0]["configuredProviderId"];
                //     let preconfigdeptid=Object.keys(filterAppointments[ehrProvider][1]);
                //     let preconfigdeptvalue=filterAppointments[ehrProvider][1]["configuredDeptId"];
                //     if(Array.isArray(preconfigprovidervalue) && preconfigprovidervalue.length>0){
                //         if(preconfigproviderid[0]==="configuredProviderId" && preconfigprovidervalue.length>0){
                //             ele["Providers"].forEach((p:Provider,index:number)=>{
                //                 for (var i=0;i<p["ProviderIDs"].length;i++){
                //                     if(preconfigprovidervalue.includes(p["ProviderIDs"][i]["ID"].trim())){
                //                         totalupcomingappointments += 1;
                //                         break;
                //                     }
                //                 }

                    //         }) 
                    //  }
                    // }
                    // else if(Array.isArray(preconfigdeptvalue) && preconfigdeptvalue.length > 0) {
                    //     if(preconfigdeptid[0]==="configuredDeptId" && preconfigdeptvalue.length>0){
                    //         ele["Providers"].forEach((p:Provider,index:number)=>{
                    //             for (var i=0;i<p["DepartmentIDs"].length;i++){
                    //                 if(preconfigdeptvalue.includes(p["DepartmentIDs"][i]["ID"].trim())){
                    //                     totalupcomingappointments += 1;
                    //                     break;
                    //                 }
                    //             }
    
                    //      }) 
                    // }
                    
        //             }
        //             else{
        //                 totalupcomingappointments += 1;
        //             }
        //             let appointmentinfo = {
        //                 appointmentdate: new Date(ele?.resource?.start).toLocaleDateString('en-us',{month:'short', day: 'numeric'}),
        //                 appointmenttime: formatdatestring(ele?.resource?.start)[1]
        //             }
        //             upappointment.push(appointmentinfo);
        //             note = `Next Appointment: ${upappointment[0].appointmentdate},${upappointment[0].appointmenttime}`
        //         }
        //         if (ele?.resource?.status) {        
        //             if (ele?.resource?.status === "noshow") {
        //                 noShowCount = noShowCount + 1;
        //             }
        //             else if (ele?.resource?.status === "completed" || presentdate > apptdate) {
        //                 pastCount = pastCount + 1;
        //             }
        //             else if (ele?.resource?.status === "Arrived") {
        //                 completecount = completecount + 1;
        //             }
        //             else if ((ele?.resource?.status === "booked")) {                               
        //                 upcomingCount = upcomingCount + 1;
        //             }
        //             else if (ele?.resource?.status === "cancelled") {
        //                 cancelledCount = cancelledCount + 1;
        //             }
        //         }
        //     });
        // }
        if(["D1C2A351-98F5-4410-BCC2-F8E76BDB2453","365563CE-EE3E-462C-AD47-9013F5933FE4"].includes(ele?.resource?.id)){
    
        }
      if (ele?.resource?.status) {
           if (presentdate <= apptdate && ele?.resource?.status === "booked") {
              upcomingCount++;
          }
          else if (ele?.resource?.status === "noshow") {
            noShowCount++;
        }  else if (ele?.resource?.status === "cancelled") {
            cancelledCount++;
        }
        else if ( presentdate > apptdate ) {
            pastCount++;
        }  
        }
    });
    }
        result['totalupcomingappointments'] = upcomingCount;    
        result['totalcancelappointments'] = cancelledCount;
        result['totalnoshow'] = noShowCount;
        result['note'] = note;
        result['chartdata'] = {
                labels: ["No Shows", "Completed", "Arrived", "Scheduled","Canceled"],
                datasets: [{
                    data: [noShowCount,pastCount,completecount,upcomingCount,cancelledCount],
                    backgroundColor: getColorCode(5),
                }]
        }
    return result;


}